import { render, staticRenderFns } from "./SiteRegistrationTable.vue?vue&type=template&id=c0c5639e"
import script from "./SiteRegistrationTable.vue?vue&type=script&lang=ts"
export * from "./SiteRegistrationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports